import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { VALID_USER }   from "apps/action_types";
import { validations }  from "apps/actions/validations";
import { save }         from "apps/actions/common";
import serializeJSON     from 'utilities/serialize_json';
class Form extends BaseAjaxForm {
  validFunction = validations.product;
  submitFunction = save;
  protected setValidations(){
    this.watchAbout('name');
    this.watchAbout('name_alt');
  }
}

riot.mixin('forms.products.save', Form as riot.TagMixin)
